import React from "react";
import { useSelector } from "react-redux";
import logo from "../../images/logo.png";

const Navbar = ({setIsHome}) => {

  const carts = useSelector(state => state.carts);

  const totalQuantity = carts.reduce((current ,cart) => cart.quantity + current, 0)

  return (
    <>
      <nav className="bg-[#171C2A] py-4">
        <div className="navBar">
          <a href="#home">
            <img src={logo} alt="LWS" className="max-w-[140px]" />
          </a>

          <div className="flex gap-4">
            <a onClick={() =>setIsHome(true)} href="#home" className="navHome" id="lws-home">
              Home
            </a>
            <a onClick={() => setIsHome(false)} href="#cart" className="navCart" id="lws-cart">
              <i className="text-xl fa-sharp fa-solid fa-bag-shopping"></i>
              <span id="lws-totalCart">{totalQuantity}</span>
            </a>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
